export default {"src":"/_next/static/media/Token_Engineering_Commons.e248ecab.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};